"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

const Document = _ref => {
  let {
    className
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", {
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: "46",
    height: "52",
    viewBox: "0 0 46 52"
  }, /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("linearGradient", {
    id: "document-a",
    x1: "20.618%",
    x2: "79.655%",
    y1: "84.924%",
    y2: "16.33%"
  }, /*#__PURE__*/_react.default.createElement("stop", {
    offset: "0%",
    stopColor: "#1D8DBA"
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: "100%",
    stopColor: "#03ECAE"
  }))), /*#__PURE__*/_react.default.createElement("path", {
    fill: "url(#document-a)",
    fillRule: "evenodd",
    d: "M39.4293929,17.8743906 C39.4293929,18.7722031 38.6921607,19.4997969 37.7865357,19.4997969 C36.8784464,19.4997969 36.1428571,18.7722031 36.1428571,17.8743906 C36.1428571,16.9761719 36.8784464,16.2489844 37.7865357,16.2489844 C38.6921607,16.2488828 39.4293929,16.9761719 39.4293929,17.8743906 L39.4293929,17.8743906 Z M39.4293929,45.5 L13.1428571,45.5 L11.5,45.5 C8.77819643,45.5 6.57060714,43.3163047 6.57060714,40.6248984 L6.57060714,38.9990859 L6.57060714,6.49928906 C6.57060714,2.90925781 9.51378571,0 13.1428571,0 L26.2865357,0 C28.10025,0 29.5706071,1.454375 29.5706071,3.24878125 L29.5706071,12.9984766 C29.5706071,14.7945078 31.0426071,16.2488828 32.8571429,16.2488828 C33.7644107,16.2488828 34.5,16.9761719 34.5,17.8742891 C34.5,18.7721016 33.7644107,19.4996953 32.8571429,19.4996953 C29.22725,19.4996953 26.2865357,16.5885078 26.2865357,12.9984766 L26.2865357,6.49928906 L26.2865357,3.24878125 L23,3.24878125 L13.1428571,3.24878125 C11.3275,3.24878125 9.85714286,4.7051875 9.85714286,6.4991875 L9.85714286,34.1247969 L9.85714286,34.4231875 L9.85714286,39.8122969 C9.85714286,41.1588125 10.9601161,42.2497969 12.3206071,42.2497969 L17.7689375,42.2497969 L18.0706071,42.2497969 L39.4293929,42.2497969 C41.2431071,42.2497969 42.7134643,40.7946094 42.7134643,38.9989844 L42.7134643,24.3735781 L42.7134643,19.4996953 L42.7134643,16.9229531 L32.6389509,6.9558125 C31.9980312,6.32145312 31.9980312,5.29272656 32.6389509,4.65836719 C33.280692,4.02441406 34.3203125,4.02441406 34.9620536,4.65836719 L45.5002634,15.0805078 C45.5019062,15.0821328 45.5034464,15.0856875 45.5050893,15.0872109 C45.8082991,15.3819453 46,15.7937812 46,16.2488828 L46,19.4996953 L46,24.3735781 L46,38.9990859 C46,42.5895234 43.0568214,45.5 39.4293929,45.5 L39.4293929,45.5 Z M31.2134643,48.7491875 C31.7918527,48.7491875 32.8571429,48.7491875 32.8571429,48.7491875 C33.7644107,48.7491875 34.5,49.4767813 34.5,50.3741875 C34.5,51.2724063 33.7644107,52 32.8571429,52 C32.6790982,52 8.21346429,52 8.21346429,52 C3.67794643,52 0,48.3612188 0,43.8748984 L0,19.4997969 C0,18.6015781 0.735589286,17.8743906 1.64285714,17.8743906 C2.55094643,17.8743906 3.28653571,18.6015781 3.28653571,19.4997969 L3.28653571,43.8748984 C3.28653571,46.5672188 5.49248214,48.7491875 8.21346429,48.7491875 L31.2134643,48.7491875 L31.2134643,48.7491875 Z M1.64285714,14.6238828 C0.735589286,14.6238828 0,13.8962891 0,12.9984766 C0,12.1022891 0.735589286,11.3751016 1.64285714,11.3751016 C2.55094643,11.3751016 3.28653571,12.1022891 3.28653571,12.9984766 C3.28653571,13.8962891 2.55094643,14.6238828 1.64285714,14.6238828 L1.64285714,14.6238828 Z"
  }));
};

Document.defaultProps = {
  className: ''
};
Document.propTypes = {
  className: _propTypes.default.string
};
var _default = Document;
exports.default = _default;